const { gql } = require("@apollo/client");

const POLE_PRICE_AUDITS = gql`
  query polePriceAudits(
    $stationIds: [String]!
    $fuelGradeIds: [ID!]!
    $periodFrom: String!
    $periodTo: String!
    $statuses: [String!]!
    $page: Int!
  ) {
    polePriceAudits(
      input: {
        stationIds: $stationIds
        fuelGradeIds: $fuelGradeIds
        periodFrom: $periodFrom
        periodTo: $periodTo
        statuses: $statuses
        page: $page
      }
    ) {
      polePriceAudits {
        id
        oldPrice
        newPrice
        status
        fuelGrade {
          id
          name
          primaryColour
        }
        station {
          id
          name
          brand {
            id
            name
            key
          }
        }
        events {
          eventAt
          type
          user {
            id
            name
          }
          cmaResponse {
            reference
          }
        }
      }
      pageInfo {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
`

export {
  POLE_PRICE_AUDITS
}